/**
 * Контракты публичных проектов wizard (E07.7, ФТ-1.7).
 * Храним только последнюю версию шага в рамках проекта и модели.
 */

import { z } from "zod";
import { apiSuccessSchema } from "./envelope";

export const projectStatusSchema = z.enum(["in_progress", "completed"]);
export type ProjectStatus = z.infer<typeof projectStatusSchema>;

export const projectStepTypeSchema = z.enum(["industry", "models", "status", "params", "result"]);
export type ProjectStepType = z.infer<typeof projectStepTypeSchema>;

const payloadSchema = z.record(z.string(), z.unknown());

export const projectSummarySchema = z.object({
  id: z.string().uuid(),
  status: projectStatusSchema,
});
export type ProjectSummary = z.infer<typeof projectSummarySchema>;

export const createProjectResponseSchema = apiSuccessSchema(projectSummarySchema);

export const saveProjectStepRequestSchema = z.object({
  stepType: projectStepTypeSchema,
  modelId: z.string().uuid().nullable().optional(),
  payload: payloadSchema,
});
export type SaveProjectStepRequest = z.infer<typeof saveProjectStepRequestSchema>;

export const projectStepSchema = z.object({
  id: z.string().uuid(),
  projectId: z.string().uuid(),
  stepType: projectStepTypeSchema,
  modelId: z.string().uuid().nullable(),
  payload: payloadSchema,
  isCurrentVersion: z.boolean(),
});
export type ProjectStep = z.infer<typeof projectStepSchema>;

export const projectStepResponseSchema = apiSuccessSchema(projectStepSchema);

export const PROJECT_ERROR_CODES = {
  NOT_FOUND: "PROJECT_NOT_FOUND",
  GUEST_LIMIT_REACHED: "GUEST_LIMIT_REACHED",
} as const;
export type ProjectErrorCode = (typeof PROJECT_ERROR_CODES)[keyof typeof PROJECT_ERROR_CODES];

export const createProjectRequestSchema = z.object({
  /** Устойчивый токен "устройства" (cookie/fingerprint), чтобы лимит проходов гостя работал без авторизации. */
  deviceToken: z.string().min(1).max(255).optional(),
  /** Персональный код зарегистрированного клиента — новый проект привязывается к нему. */
  personalCode: z.string().trim().length(8).optional(),
});

export type CreateProjectRequest = z.infer<typeof createProjectRequestSchema>;
